module.exports = __webpack_public_path__ + "img/ic_comerciante.4d948b9f.svg";